export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 px-4 md:px-6 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              关于本站
            </h2>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
            <div className="prose-custom space-y-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                <strong className="text-foreground-900">在线吃瓜</strong>成立于 2023 年，是国内领先的免费娱乐八卦内容聚合平台。
                我们致力于为广大网友提供最新、最全、最有趣味的吃瓜内容，无需注册、无需付费，
                一个入口看遍全网热门八卦。
              </p>
              <p>
                我们的编辑团队每天从微博、抖音、小红书、豆瓣、知乎等主流平台海量信息中，
                精心筛选最具话题性、最有看点的内容，让你用最少的时间，获取最有价值的吃瓜资讯。
              </p>
              <p>
                作为一个独立内容聚合平台，我们始终坚持<strong className="text-foreground-900">免费开放、匿名浏览</strong>的原则，
                不收集用户个人信息，不设置任何付费墙。我们相信，吃瓜应该是每个人都能轻松享受的快乐。
                目前平台日均服务超过百万瓜友，已成为中文互联网最受欢迎的免费吃瓜入口之一。
              </p>
              <p>
                如果你有任何建议、爆料或合作意向，欢迎通过「投稿爆料」区域的联系方式与我们取得联系。
                在线吃瓜，让每一天都多一点乐趣。
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-8 pt-6 border-t border-background-200/60">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-500 font-heading">100万+</div>
                <div className="text-xs text-foreground-500 mt-1">日均访问</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-500 font-heading">50万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃瓜友</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary-500 font-heading">3年</div>
                <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}